import { TypographyH1, TypographyLead } from "#app/components/ui/typography.tsx";

export default function WhatsNextRoute() {
  return (
    <div>
      <TypographyH1 className="mb-3">What's next?</TypographyH1>
      <TypographyLead>What do you do now?</TypographyLead>
    </div>
  );
}
